import {
  ActivityListing_ListingFragment,
  ClassDetailsNoSectionsQuery,
  ListingCard_ListingFragment,
  OtherListingsByTeacherQuery as OtherListingsByTeacherQueryType,
  OtherListingsByTeacherQueryVariables,
} from "@outschool/gql-frontend-generated";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useMemo } from "react";

import OtherListingsByTeacherQuery, {
  OtherListingsByTeacherMobileVariable,
  OtherListingsByTeacherQueryMobile,
  OtherListingsByTeacherVariable,
} from "../graphql/OtherListingsByTeacherQuery";
import { getActivityUpsellListing } from "../helpers";

export const useActivityTeacherUpsellListing = (
  activity: ClassDetailsNoSectionsQuery["activity"]
): ActivityListing_ListingFragment | undefined => {
  const variables = useMemo(
    () => OtherListingsByTeacherMobileVariable(activity),
    [activity]
  );
  const { data } = useQueryWithPreviousData(
    OtherListingsByTeacherQueryMobile,
    variables
  );

  const allListingsFromTeacher = data?.listing?.similarListings?.sameTeacher;

  const upsellListing = (
    !!allListingsFromTeacher?.length
      ? getActivityUpsellListing(allListingsFromTeacher, activity)
      : undefined
  ) as ActivityListing_ListingFragment | undefined;

  return upsellListing;
};

export const useActivityCardTeacherListings = (
  activity: ClassDetailsNoSectionsQuery["activity"]
) => {
  const variables = useMemo(
    () => OtherListingsByTeacherVariable(activity),
    [activity]
  );

  const { data } = useQueryWithPreviousData<
    OtherListingsByTeacherQueryType,
    OtherListingsByTeacherQueryVariables
  >(OtherListingsByTeacherQuery, variables);

  const allListings: ListingCard_ListingFragment[] | undefined =
    data?.listing?.similarListings?.sameTeacher;

  return allListings;
};
